import React from 'react';
import { Star, Music, Sparkles } from 'lucide-react';

const ArtistManagementPage = () => {
  const bollywoodActresses = [
    "Meghna Naidu",
    "Alankrita Sahai",
    "Monica Bedi",
    "Monalisa",
    "Rani Chatterjee",
    "Manara Chopra",
    "Minisha Lamba",
    "Karishma Kotak",
    "Nimrit Kaur",
    "Aarti Chabbaria",
    "Ishita Raj Sharma",
    "Rashmi Desai",
    "Nikita Dutta",
    "Nia Sharma",
    "Georgia Andriani",
    "Sanjeeda Shaikh",
    "Karishma Tanna",
    "Rimi Sen",
    "Akanksha Puri",
    "Lauren Gottlieb",
    "Amyra Dastur",
    "Shamita Shetty",
    "Esha Deol",
    "Daisy Shah",
    "Zareen Khan",
    "Elli Avram",
    "Sofia Chaudhary",
    "Chitrangada Singh",
    "Neha Sharma",
    "Nushrat Bharucha",
    "Nargis Fakhri",
    "Mouni Roy",
    "Krystle D'Souza",
    "Ayesha Khan",
    "Malaika Arora",
    "Sunny Leone",
    "Urvashi Rautela"
  ];

  const commercialSingers = [
    "Jubin Nautiyal",
    "Badshah",
    "Sunidhi Chauhan",
    "Sonu Nigam",
    "Shreya Ghoshal",
    "Neha Kakkar",
    "Vishal Shekhar",
    "Amit Trivedi",
    "Armaan Malik",
    "Mohit Chauhan",
    "Mika Singh",
    "B Praak",
    "Sukhwinder Singh",
    "Darshan Raval",
    "Kailash Kher",
    "Shaan",
    "Salim Sulaiman"
  ];

  const singerOptions = [
    "Rupali Jagga",
    "Jyotica Tangri",
    "Abhijeet Sawant",
    "Arunita Kanjilal",
    "Salman Ali",
    "Aakriti Kakar",
    "Divya Kumar",
    "Irfan Khan",
    "Pawandeep Rajan",
    "Sukriti Kakar and Prakriti Kakar",
    "Amit Mishra",
    "Arjun Kanungo",
    "Nakash Aziz",
    "Shalmali Kholgade",
    "Tulsi Kumar",
    "Sona Mohapatra",
    "Jasleen Royal",
    "Tony Kakkar",
    "Monali Thakur",
    "Neha Bhasin",
    "Aastha Gill",
    "Javed Ali",
    "Benny Dayal",
    "Amaal Mallik",
    "Harshdeep Kaur",
    "Kanika Kapoor",
    "Papon",
    "Neeti Mohan",
    "Sachin-Jigar",
    "Shilpa Rao",
    "Kailash Kher",
    "Shaan",
    "Sukhwinder Singh",
    "Mohit Chauhan",
    "Mika Singh",
    "B Praak",
    "Amit Trivedi",
    "Vishal Shekhar"
  ];

  return (
    <div className="min-h-screen bg-black">
      {/* Hero Section */}
      <section className="py-24 px-6 bg-gradient-to-b from-zinc-900 to-black">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="heading-font text-5xl md:text-6xl font-bold text-white mb-6">
            Artist Management
          </h1>
          <div className="w-24 h-1 gold-bg mx-auto mb-8"></div>
          <p className="body-font text-xl text-gray-300 max-w-3xl mx-auto">
            Access to India's finest performers, curated for your exclusive events
          </p>
        </div>
      </section>

      {/* Bollywood Actresses */}
      <section className="py-16 px-6 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-12">
            <Star className="gold-accent" size={32} />
            <h2 className="heading-font text-4xl font-bold text-white">
              Bollywood Item Performance Actresses
            </h2>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {bollywoodActresses.map((actress, idx) => (
              <div 
                key={idx}
                className="bg-zinc-900 p-4 rounded-sm border border-zinc-800 hover:border-yellow-600 transition-all text-center"
              >
                <p className="body-font text-white">{actress}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Commercial Singers */}
      <section className="py-16 px-6 bg-zinc-900">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-12">
            <Music className="gold-accent" size={32} />
            <h2 className="heading-font text-4xl font-bold text-white">
              Commercial Singers
            </h2>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {commercialSingers.map((singer, idx) => (
              <div 
                key={idx}
                className="bg-black p-4 rounded-sm border border-zinc-800 hover:border-yellow-600 transition-all text-center"
              >
                <p className="body-font text-white">{singer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Singer Options */}
      <section className="py-16 px-6 bg-black">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-center justify-center gap-3 mb-12">
            <Sparkles className="gold-accent" size={32} />
            <h2 className="heading-font text-4xl font-bold text-white">
              Singer Options
            </h2>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {singerOptions.map((singer, idx) => (
              <div 
                key={idx}
                className="bg-zinc-900 p-4 rounded-sm border border-zinc-800 hover:border-yellow-600 transition-all text-center"
              >
                <p className="body-font text-white">{singer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 px-6 bg-gradient-to-b from-black to-zinc-900">
        <div className="max-w-4xl mx-auto text-center">
          <h3 className="heading-font text-3xl font-bold text-white mb-6">
            Book Your Artist
          </h3>
          <p className="body-font text-lg text-gray-300 mb-8">
            Contact us to discuss availability, pricing, and event requirements
          </p>
          <a 
            href="/contact"
            className="inline-block gold-bg text-black px-8 py-4 rounded-sm font-semibold body-font hover:bg-yellow-600 transition-colors"
          >
            Get In Touch
          </a>
        </div>
      </section>
    </div>
  );
};

export default ArtistManagementPage;
